import type { IPlatformData } from '@wix/editor-elements-integrations';
import { withCompController } from '@wix/editor-elements-integrations';
import type { WRichTextProps } from '@wix/thunderbolt-components';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type { IWRichTextProps } from '../WRichText.types';
import { wrichtextListInRtlExperiment } from '../constants';

// Should be removed after the specs.thunderbolt.WRichTextVerticalAlignTopSafariAndIOS,
// specs.thunderbolt.wrichtextListInRtl
// specs.thunderbolt.classNameToRoot
// specs.thunderbolt.textScaleAdjust
// are open to 100%
export const useComponentProps = ({
  mapperProps,
  stateValues,
}: IPlatformData<IWRichTextProps, WRichTextProps>): IWRichTextProps => {
  const { experiments = {} } = stateValues;
  const shouldFixVerticalTopAlignment = isExperimentOpen(
    experiments,
    'specs.thunderbolt.WRichTextVerticalAlignTopSafariAndIOS',
  );

  const isListInRtlEnabled = isExperimentOpen(
    experiments,
    wrichtextListInRtlExperiment,
  );

  const isClassNameToRootEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.isClassNameToRootEnabled',
  );

  const isTextScaleAdjustEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.textScaleAdjust',
  );

  return {
    ...mapperProps,
    shouldFixVerticalTopAlignment,
    isListInRtlEnabled,
    isClassNameToRootEnabled,
    isTextScaleAdjustEnabled,
  };
};

export default withCompController(useComponentProps);
